var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoltage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.2 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.58,5.96h3.07l-3.07,7.99,4.77-2.77-2.33,9.55,1.37-.63-2.86,4.42-1.09-5.03,1.12,1.02.61-5.8-4.47,2.68,2.89-11.43Zm16.19,16.25L17.86,1.6c-1.23-2.13-4.3-2.13-5.52,0L.43,22.22c-1.23,2.13.31,4.78,2.76,4.78h23.81c2.46,0,3.99-2.66,2.76-4.78ZM16.36,2.47l11.91,20.62c.56.97-.14,2.17-1.26,2.17H3.19c-1.12,0-1.81-1.21-1.26-2.17L13.84,2.47c.56-.97,1.95-.97,2.51,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltage);
export default __webpack_public_path__ + "static/media/Voltage.edc8340952f4e9024b0bac5c84445398.svg";
export { ForwardRef as ReactComponent };